import { assertUnreachable } from "common/utils/assertUnreachable";
import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_9: DocMigration = {
  maxSchemaVersion: "0.0.9",
  apply(json: any) {
    if (json.planOutputConfig) {
      const { staticPlanSheets } = json.planOutputConfig;
      for (let i = 0, l = staticPlanSheets.length; i < l; i++) {
        const staticPlanSheet = staticPlanSheets[i];
        const { type, pageName, sheetNumberPrefix, sheetNumber, disabled, sheetURL } = staticPlanSheet;
        if (typeof type === "number") {
          switch (type) {
            case 0:
              staticPlanSheets[i] = {
                id: uid(),
                name: pageName,
                url: sheetURL,
                scaleMode: "UNIFORM",
                scale: 1,
                builderOptionID: "",
                disabled,
                fillPage: false,
                sheetNumberPrefix,
                sheetNumber,
              };
              break;
            case 1:
              staticPlanSheet.type = "REMOVE";
              break;
            default: {
              assertUnreachable(staticPlanSheet as never);
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_9;
